<template>
  <div
    class="header"
  >
    <div class="d-flex align-items-center">
      <div class="w-100">
        <div class="title">
          <img
            v-if="collection.header_image"
            class=""
            :src="collection.header_image"
            alt=""
          >
          <h1>{{ collection.title }}</h1>
        </div>
        <p v-if="collection.subheader">
          {{ collection.subheader }}
        </p>
        <div class="description">
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-if="collection.description"
            class="collection-body"
            v-html="collection.description"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    collection: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style type="text/css" scoped>
.header {
  width: 100%;
  padding: 0 24px;
  margin-bottom: 24px;
  font-family: Roboto, sans-serif;
}

.title {
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.title img {
  margin-right: 16px;
  height: 40px;
}

.title h1 {
  font-family: Barlow, sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
  margin: 0;
  padding: 0;
}

.header p {
  text-align: center;
}

.collection-body {
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  max-width: 980px;
  margin: 0 auto;
}

@media (max-width: 767.98px) {
  .header {
    padding: 0;
  }
}
</style>
